import * as Parse from 'parse';
import { BenefitModel, ConclusionModel, FileModel, GrabFormModel, MetaImage, ProjectModel, ReviewModel, StringModel, UspModel, WorkModel} from '.';
import { ModelDecorator } from '../decorators';

export default class Service extends Parse.Object {

    @ModelDecorator.Variable
    public img: FileModel;

    @ModelDecorator.Variable
    public title: StringModel;

    @ModelDecorator.Variable
    public shortDescription: StringModel;

    @ModelDecorator.Variable
    public position: number;

    @ModelDecorator.Variable
    public published: boolean;

    @ModelDecorator.Variable
    public benefits: BenefitModel[] | any;

    @ModelDecorator.Variable
    public usp: UspModel | any;

    @ModelDecorator.Variable
    public conclusion: ConclusionModel | any;

    @ModelDecorator.Variable
    public minPrice: number;

    @ModelDecorator.Variable
    public metaImages: MetaImage;

    @ModelDecorator.Variable
    public keywords: StringModel;

    @ModelDecorator.Variable
    public grabForm: GrabFormModel.default | any;

    @ModelDecorator.Variable
    public friendlyServices: Service[] | any;

    @ModelDecorator.Variable
    public projects: ProjectModel[] | any;

    @ModelDecorator.Variable
    public reviews: ReviewModel[] | any;

    @ModelDecorator.Variable
    public works: WorkModel[] | any;

    @ModelDecorator.Variable
    public worksUsp: StringModel;

    constructor() {
        super('Service');
        this.title = new StringModel();
        this.shortDescription = new StringModel();
        this.worksUsp = new StringModel();
        this.img = new FileModel();
        this.img.alt = new StringModel();
        this.usp = null;
        this.conclusion = null;
        this.benefits = [];
        this.keywords = new StringModel();
        this.published = false;
        this.metaImages = new MetaImage();
        this.grabForm = new GrabFormModel.default();
        this.friendlyServices = [];
        this.projects = [];
        this.reviews = [];
        this.works = [];
    }

    // tslint:disable-next-line:member-ordering
    public static async getServicesCount() {
        return new Parse.Query(Service).count()
    }

    // tslint:disable-next-line:member-ordering
    public static async searchService(s: string, limit: number, skip: number, isCount = false, excludeId: string = '') {
        const stringQuery = new Parse.Query(StringModel);
        stringQuery.matches('ru', new RegExp(s, 'i'), null);
        const searchQuery = new Parse.Query(Service)
        searchQuery.descending('date')
        searchQuery.include(['title', 'img'])
        searchQuery.matchesQuery('title', stringQuery)
        if (isCount) {
            return searchQuery.count();
        } else {
            searchQuery.limit(limit);
            if (excludeId) {
                searchQuery.notEqualTo('objectId', excludeId);
            }
            searchQuery.skip(skip);
            return searchQuery.find();
        }

    }

    // tslint:disable-next-line:member-ordering
    public static async deleteAllServices(services: Service[]) {
        const subobjectForDelete: any[] = [];
        const mainobjectForDelete: any[] = [];
        services.forEach((s) => {
            if (s.img.alt) {
                subobjectForDelete.push(s.img.alt);
            }
            subobjectForDelete.push(s.title);
            subobjectForDelete.push(s.shortDescription);
            mainobjectForDelete.push(s.img);
            mainobjectForDelete.push(s);
        })
        await Service.destroyAll(subobjectForDelete);
        await Service.destroyAll(mainobjectForDelete);
    }

    // tslint:disable-next-line:member-ordering
    public static async loadServices(skip = 0, limit = 25) {
        return await new Parse.Query(Service)
            .descending('date')
            .include(['title', 'img'])
            .limit(limit)
            .skip(skip)
            .find()
    }

    // tslint:disable-next-line:member-ordering
    public static async loadService(serviceId: string) {
        const serviceQuery = await new Parse.Query(Service);
        serviceQuery.include(['title', 'shortDescription', 'img', 'usp', 'benefits', 'conclusion', 'metaImages', 'keywords', 'works', 'grabForm', 'friendlyServices', 'reviews', 'projects']);
        const service = await serviceQuery.get(serviceId);
        service.img.alt = service.img.alt ? await service.img.alt.fetch() : new StringModel();
        if (service.benefits.length) {
            for (const b of service.benefits) {
                await b.title.fetch()
            }
        }
        service.friendlyServices = service.friendlyServices ? service.friendlyServices : []
        service.projects = service.projects ? service.projects : []
        service.works = service.works ? service.works : []
        service.reviews = service.reviews ? service.reviews : []
        if (service.friendlyServices.length) {
            for (const fs of service.friendlyServices) {
                await fs.title.fetch()
            }
        }
        if (service.projects.length) {
            for (const project of service.projects) {
                await project.title.fetch()
            }
        }
        if (service.works.length) {
            for (const w of service.works) {
                await w.name.fetch()
            }
        }
        return service;
    }

    public async saveFullService() {
        await this.title.save();
        await this.shortDescription.save();
        if (this.worksUsp && (this.worksUsp.ru || this.worksUsp.en)) {
            this.worksUsp.save();
        }
        await this.img.save()
        if (this.metaImages && (this.metaImages.fb || this.metaImages.vk || this.metaImages.twitter)) { await this.metaImages.save() }
        if (this.img.alt) { await this.img.alt.save() }
        if (this.img.ru && !this.img.ru.url) { await this.img.ru.save(); }
        if (this.img.en && !this.img.en.url) { await this.img.en.save(); }
        await this.save();
    }

}

Parse.Object.registerSubclass('Service', Service);


// WEBPACK FOOTER //
// ./src/models/Service.ts